import React from 'react';

function Hero() {
  return (
    <div className="container">

      {/* Heading Section */}
      <div className="row py-4 py-md-5 mt-4 mt-md-5 border-bottom text-center">
        <div className="col-12">
          <h1>Pricing</h1>
          <h3 className="text-muted mt-3 fs-5 px-2">
            Free equity investments and flat ₹20 intraday and F&O trades
          </h3>
        </div>
      </div>

      {/* Cards Section */}
      <div className="row py-4 text-center">

        {/* Card 1 */}
        <div className="col-12 col-md-4 mb-4">
          <img
            src="media/pricingEquity.svg"
            alt="Equity"
            className="img-fluid mb-3"
          />
          <h2 className="fs-4">Free equity delivery</h2>
          <p className="text-muted">
            All equity delivery investments (NSE, BSE) are absolutely free – ₹0 brokerage.
          </p>
        </div>

        {/* Card 2 */}
        <div className="col-12 col-md-4 mb-4">
          <img
            src="media/intradayTrades.svg"
            alt="Intraday"
            className="img-fluid mb-3"
          />
          <h2 className="fs-4">Intraday and F&O trades</h2>
          <p className="text-muted">
            Flat ₹20 or 0.03% (whichever is lower) per executed order on intraday trades.
          </p>
        </div>

        {/* Card 3 */}
        <div className="col-12 col-md-4 mb-4">
          <img
            src="media/pricingMF.svg"
            alt="Mutual Funds"
            className="img-fluid mb-3"
          />
          <h2 className="fs-4">Free direct MF</h2>
          <p className="text-muted">
            Direct mutual fund investments are completely free – no hidden charges.
          </p>
        </div>

      </div>

    </div>
  );
}

export default Hero;